'use client';

import React from 'react';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';

const ClaimBusinessCTA = ({ businessId, businessName }) => {
  const claimUrl = `https://pro.agora.red/login?utm_source=marketplace&utm_medium=claim_business&claim_business_id=${encodeURIComponent(businessId)}&claim_business_name=${encodeURIComponent(businessName)}`;

  return (
    <div className="rounded-2xl bg-gradient-to-br from-primary-50 via-white to-blue-50 border border-primary-100 p-6 sm:p-8">
      <h3 className="text-lg font-bold text-[#1a1a1a] tracking-[-0.01em]">
        ¿Es tu negocio?
      </h3>
      <p className="mt-2 text-[13px] text-gray-500 leading-relaxed max-w-md">
        Reclamá este negocio para administrar tu perfil, agregar servicios con precios y recibir reservas a través de Ágora.
      </p>
      <a
        href={claimUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackEvent(EVENTS.DIRECTORY_CLAIM_BUSINESS_CLICKED, { business_id: businessId, business_name: businessName })}
        className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-primary-500 text-white text-[13px] font-medium hover:bg-primary-600 active:scale-[0.98] transition-all duration-200 shadow-sm shadow-primary-500/20"
      >
        Reclamar este negocio
      </a>
    </div>
  );
};

export default ClaimBusinessCTA;
